import React from 'react';

export default function Address(props) {
  const address = props.item

  return <div className="address">
    <p>{ address.address1 }</p>
    { address.address2 ? <p className="address2">{ address.address2 }</p> : null }
    <p>{address.city}, {address.province_code ? (address.province_code + ', ') : ''}{address.country}</p>
    <p>{ address.zip }</p>
    <p>{ address.phone }</p>
  </div>

}
